import type Action from 'constants/action-types'
import {
  SET_LOG_EVENTS_COUNT_DATA,
  SET_FETCHING_LOG_EVENTS_COUNT_DATA,
} from 'constants/action-types'
import type { ChartState } from 'types/search/chart'

const initialState: ChartState = {
  data: [],
  interval: null,
  isFetching: false,
}

const chartReducer = (
  state: ChartState = initialState,
  action: Action,
): ChartState => {
  switch (action.type) {
    case SET_LOG_EVENTS_COUNT_DATA:
      return {
        ...state,
        data: action.payload.data,
        interval: action.payload.interval,
      }

    case SET_FETCHING_LOG_EVENTS_COUNT_DATA:
      return {
        ...state,
        isFetching: action.payload,
      }

    default:
      return state
  }
}

export default chartReducer
